import React from 'react'
import { SubheadProps } from '../../../../../typography/Subhead/Subhead'
import { StyledPNSubhead } from './PNSubhead.styled'

export const PNSubhead: React.FC<SubheadProps> = (props) => {
    return <StyledPNSubhead {...props} />
}
PNSubhead.displayName = 'PNSubhead'
